import axios from 'axios';
import { clearStoreage } from '../utils/helper';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // https://newtestclients.myavis.gr/
  // baseURL: 'https://extranewtestclients.myavis.gr',
});

instance.defaults.headers.common['Content-Type'] = 'application/json';

instance.interceptors.request.use(function (config) {
  const accessToken = localStorage.getItem('jwt');
  config.headers.Authorization = config.headers.Authorization
    ? config.headers.Authorization
    : `Bearer ${accessToken}`;

  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // const originalRequest = error.config;
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      clearStoreage();
      window.location.href = '/';
    }
    const parts = error.response?.request.responseURL.split('/');

    if (status === 404 && parts[parts.length - 1] === 'logout') {
      window.location.href = '/';
    }

    // todo redirect to login page when unauthorized
    /* if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await refreshAccessTokenFn();
      return instance(originalRequest);
    } */
    return Promise.reject(error);
  }
);
